import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';

import { withRouter } from 'react-router-dom';

import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import ico_plus_green from '../assets/images/ico_plus_green.png';
import ico_view from '../assets/images/ico_view.png';
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";

let addClassInstruction = null;
let addStudentInstruction = null;
let PNInstruction = null;
let WSSInstruction = null;
let CopyrightInstruction = null;
let KidsignInstruction = null;

class AdminComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { teachers: [], teacherToEdit: {}, addTeacher: false, editTeacher: false };
        this.handleAddTeacher = this.handleAddTeacher.bind(this);
    }

    componentDidMount() {
        if(this.props.user.id == 100){
            this.listTeachers();
        }else{
            this.props.history.push("/content");
        }
    }

    listTeachers() {
        REST.listTeachers().then((response) => {
            if (response.success) {
                this.setTeachers(response.body);
            }
            else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    setTeachers = (object) => {
        this.setState({ teachers: object });
    }

    handleAddTeacher(event) {
        this.setState({ addTeacher: !this.state.addTeacher, editTeacher: false });
    }

    handleCancel = () => {
        this.setState({ addTeacher: false, editTeacher: false });
    }

     handleTeacherItemClick = (object) => {
        this.setState({ addTeacher: false, editTeacher: true, teacherToEdit: null });
        this.handleAddTeacher();
        this.setState({ addTeacher: false, editTeacher: true, teacherToEdit: object });
        console.log(object);
    }

    handleLogout = () => {
        REST.logout().then((response) => {
            if(localStorage.getItem('addClass') === 'hide'){
                addClassInstruction = localStorage.getItem('addClass');
            }
            if(localStorage.getItem('addStudent') === 'hide'){
                addStudentInstruction = localStorage.getItem('addStudent');
            }
            localStorage.removeItem('token');
            if(addClassInstruction !== null){
                localStorage.setItem('addClass',addClassInstruction);
            }
            if(addStudentInstruction !== null){
                localStorage.setItem('addStudent',addStudentInstruction);
            }
            this.props.history.push("/login");
        }, (error) => {
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        });
    }

    teacherAdded = () => {
        this.listTeachers();
    }

    render() {
        return (
            <div>
                <HeaderComponent admin={true}  userId={this.props.user.id} logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className={"row"}>
                                <div className={"col-md-10"}>
                                    <h1 className="fl">Teachers</h1>
                                </div>
                                <div className={"col-md-2"}>
                                    <a className="fr">
                                        <img src={ico_plus_green} onClick={this.handleAddTeacher} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                                    </a>
                                </div>
                                </div>
                                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable">
                                    <TeachersListComponent teachers={this.state.teachers} handleItemClick={this.handleTeacherItemClick} />
                                </div>
                            </div>
                            {this.state.addTeacher ?
                                <div className="col-md-9 container navbar-container">
                                    <AddTeacherComponent handleTeacherAdded={this.teacherAdded} handleCancel={this.handleCancel} />
                                </div> : null}
                            {this.state.editTeacher ?
                                <div className="col-md-9 container navbar-container">
                                    <UpdateTeacherComponent handleTeacherUpdated={this.teacherAdded} teacher={this.state.teacherToEdit} handleCancel={this.handleCancel} />
                                </div> : null}
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}

class AddTeacherComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { firstname: '', lastname: '', email: '', modalDialog:false, responseContent:'' };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleName(event) {
        this.setState({ firstname: event.target.value });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
    }

    handleSave(event) {
        REST.createTeacher(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'Teacher Successfully Added!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},3500);
                this.props.handleTeacherAdded();
                this.myFormRef.reset();
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddTeacher" ref={(el) => this.myFormRef = el}>
                    <label htmlFor="inputTeacherName">First Name</label>
                    <input type="text" onChange={this.handleName} id="inputTeacherName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Last Name</label>
                    <input type="text" onChange={this.handleLastName} id="inputTeacherLastName" className="form-control" placeholder="Last Name" required />
                    <label htmlFor="inputTeacherEmail">Email</label>
                    <input type="text" onChange={this.handleEmail} id="inputTeacherEmail" className="form-control" placeholder="Email" required />
                </form>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class UpdateTeacherComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { firstname: this.props.teacher.user.firstname, lastname: this.props.teacher.user.lastname, email: this.props.teacher.user.email, userId: this.props.teacher.userId, researcher: this.props.teacher.researcher, modalDialog:false, modalDialogDelete:false };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleUserId = this.handleUserId.bind(this);
        this.handleReseacher = this.handleReseacher.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteTeacher = this.deleteTeacher.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.teacher.userId !== newProps.teacher.userId){
            this.setState({ firstname: this.props.teacher.user.firstname, lastname: this.props.teacher.user.lastname, email: this.props.teacher.user.email, userId: this.props.teacher.userId, researcher: this.props.teacher.researcher, modalDialog:false,modalDialogDelete:false });
        }
    }

    deleteTeacher = (confirm) =>{
        if(confirm) {
            this.handleDelete();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleName(event) {
        this.setState({ firstname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleUserId(event) {
        this.setState({ userId: event.target.value });
        event.preventDefault();
    }

    handleReseacher(event) {
        this.setState({ researcher: !this.state.researcher });
        // event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
        event.preventDefault();
    }

    handleSave(event) {
        REST.updateTeacher(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Data Successfully Updated!'
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
                this.props.handleTeacherUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
        event.preventDefault();
    }

    handleDelete(event) {
        REST.deleteTeacher(this.state.userId).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Successfully Deleted!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},3500);
                this.props.handleTeacherUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <DeleteDialogBox
                    confirmDelete={this.deleteTeacher}
                    modalOpen={this.state.modalDialogDelete}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form>
                    <label htmlFor="inputTeacherName">First Name</label>
                    <input type="text" value={this.state.firstname} onChange={this.handleName} id="inputTeacherName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Last Name</label>
                    <input type="text" value={this.state.lastname} onChange={this.handleLastName} id="inputTeacherLastName" className="form-control" placeholder="Last Name" required />
                    {/*<label htmlFor="inputTeacherEmail">Email</label>*/}
                    {/*<input type="text" onChange={this.handleEmail} id="inputTeacherEmail" value={this.state.email} className="form-control" placeholder="Email" required />*/}
                    <label htmlFor="inputTeacherUserId">User Number</label>
                    <input type="text" value={this.state.userId} onChange={this.handleUserId} id="inputTeacherUserId" className="form-control" placeholder="UserID" required />
                    <label style={{width:'30%'}}> </label>
                    <div style={{display:'inline-block', position:'relative', width:'70%'}}>
                    <label htmlFor="cbResearcher" className="cb "><input type="checkbox" onChange={this.handleReseacher} name="researcher" checked={this.state.researcher} id="cbResearcher" /><span className="checkmark"></span> Researcher</label>
                    </div><br />
                </form>
                <div className="nav navbar fl">
                    <a onClick={(event)=>{this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TEACHER?'});   event.stopPropagation();}} className="handBtn">
                        <span>Delete Teacher</span>
                    </a>
                </div>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class TeachersListComponent extends Component {
    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    }

    render() {
        let items = this.props.teachers;
        const teachers = items.map((item) => {
            if (item.user) {
                return <TeachersListItemComponent key={item.id} item={item} handleClick={this.handleItemClick} />
            }
            else return null;
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                    {teachers}
                </tbody>
            </table>
        );
    }
}

class TeachersListItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    render() {
        return (
            <tr className="clickable-row" onClick={this.handleClick}>
                <td>{this.props.item.user.lastname}, {this.props.item.user.firstname}</td>
                <td className="fitWidth">
                    <a>
                        <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        );
    }
}

export default withRouter(AdminComponent);


// WEBPACK FOOTER //
// ./src/AdminComponent/Admin.js